import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, switchMap, throwError } from "rxjs";
import { DialogService } from "src/app/shared/services/dialog.service";
import { LoaderService } from "src/app/shared/services/loader.service";
import { SessionService } from "src/app/shared/services/session.service";
import en from 'src/assets/i18n/en';  
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    translations = en;
    constructor(private _dialogService: DialogService, private _loaderService: LoaderService, private _sessionService: SessionService) {
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
        .pipe(
            catchError((error: HttpErrorResponse) => {
                if(error.status == 400 || error.status == 500) {
                    this._loaderService.forceHideLoader();
                    // No More ERROR DIALOG - MHB
                    this._dialogService.showDialog(
                        this.translations.common.warning,
                        this.translations.common.somethingWentWrong
                    );
                }
                if (error.status === 401) {
                    const url = request.url.toLowerCase();
                    const isAuthenticationRequest = url.includes('/authenticate') || url.includes('/verify-otp') ||
                        url.includes('/generateotp') || url.includes('/refreshtoken');
                    const canRefresh = !isAuthenticationRequest && !request.headers.has('X-Skip-Session-Refresh') &&
                        !request.headers.has('X-Session-Retry');

                    if (canRefresh) {
                        return this._sessionService.refreshSession().pipe(
                            switchMap(refreshed => {
                                if (refreshed) {
                                    const token = localStorage.getItem('QNBNToken') || '';
                                    return next.handle(request.clone({
                                        setHeaders: { Authorization: `Bearer ${token}`, 'X-Session-Retry': 'true' }
                                    }));
                                }

                                this._sessionService.endSession();
                                return throwError(() => error);
                            })
                        );
                    }

                    if (!isAuthenticationRequest && !request.headers.has('X-Skip-Session-Refresh')) {
                        this._sessionService.endSession();
                    }
                }
                return throwError(() => error);
            })
        )
    }
}
